<div class="information-notice-container">
  <img src="assets/img/info-circle.svg" />
  <p class="caption2--medium">{{ trans(text) }}</p>
</div>
